$(document).ready(function () {
  $('.faq-item__head').on('click', function () {
    const $parent = $(this).closest('.faq-item')
    const $description = $parent.find('.faq-item__description')

    $('.faq-item').not($parent).removeClass('is-active')
    $parent.toggleClass('is-active')

    $description.slideToggle()
    $('.faq-item__description').not($description).slideUp()
  })

  $(function () {
    $('a[href^="#"]').click(function (e) {
      e.preventDefault()

      var target = $(this).attr('href')
      if (target === '#') return

      var headerHeight = $('.header').outerHeight() || 0

      $('html, body').animate(
        {
          scrollTop: $(target).offset().top - headerHeight,
        },
        800
      )

      $('.btn--burger').removeClass('is-active')
      $('body').removeClass('menu-open')
      $('.menu').removeClass('is-active')
      $('html').removeClass('is-ovh')
    })
  })

  // BURGER
  $('.btn--burger').on('click', function () {
    $(this).toggleClass('is-active')
    $('body').toggleClass('menu-open')
    $('.menu').toggleClass('is-active')
    $('html').toggleClass('is-ovh')
  })

  // ANIMATION
  gsap.registerPlugin(ScrollTrigger)

  gsap.from('.about__dec--l', {
    scrollTrigger: {
      trigger: '.about',
      start: 'top 80%',
      toggleActions: 'play none none reset',
    },
    x: -100,
    opacity: 0,
    rotation: -180,
    duration: 1,
    ease: 'back.out(1.7)',
  })

  gsap.from('.about__dec--r', {
    scrollTrigger: {
      trigger: '.about',
      start: 'top 80%',
      toggleActions: 'play none none reset',
    },
    x: 100,
    opacity: 0,
    rotation: 180,
    duration: 1,
    ease: 'back.out(1.7)',
  })

  gsap.from('.about__sign', {
    scrollTrigger: {
      trigger: '.about',
      start: 'top 80%',
      toggleActions: 'play none none reset',
    },
    scale: 0.5,
    opacity: 0,
    duration: 1,
    ease: 'elastic.out(1, 0.5)',
    delay: 0.3,
  })

  gsap.from('.about__item', {
    scrollTrigger: {
      trigger: '.about__items',
      start: 'top 75%',
      toggleActions: 'play none none reset',
    },
    y: 60,
    opacity: 0,
    duration: 0.8,
    stagger: 0.15,
    ease: 'power3.out',
  })

  // Light Gallery
  // Light gallery
  var lengthThumbs = $('.lightgallery-mini img').length

  if (lengthThumbs <= 5) {
    $('.lightgallery').on(
      'beforeChange',
      function (event, slick, currentSlide, nextSlide) {
        $('.lightgallery-mini .slick-slide').removeClass(
          'slick-current slick-active'
        )
        $('.lightgallery-mini .slick-slide')
          .eq(nextSlide)
          .addClass('slick-current slick-active')
      }
    )

    $('.lightgallery-mini').on(
      'afterChange',
      function (event, slick, currentSlide, nextSlide) {
        $('.lightgallery').slick('slickGoTo', currentSlide)
      }
    )

    setTimeout(function () {
      $('.lightgallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        draggable: false,
        variableWidth: false,
      })

      $('.lightgallery-mini').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        focusOnSelect: true,
        variableWidth: false,
        centerMode: true,
        draggable: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              asNavFor: '.lightgallery',
              dots: true,
              arrows: false,
              focusOnSelect: true,
              draggable: true,
              variableWidth: false,
              dots: false,
            },
          },
        ],
      })
    }, 10)
  } else {
    setTimeout(function () {
      $('.lightgallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        asNavFor: '.lightgallery-mini',
        draggable: false,
        variableWidth: false,
        infinite: false,
      })

      $('.lightgallery-mini').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.lightgallery',
        dots: false,
        focusOnSelect: true,
        variableWidth: false,
        centerMode: true,
        draggable: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              asNavFor: '.lightgallery',
              dots: true,
              arrows: false,
              focusOnSelect: true,
              draggable: true,
              variableWidth: false,
              dots: false,
            },
          },
        ],
      })
    }, 10)
  }

  if ($(window).width() > 1024) {
    $('#lightgallery').lightGallery({
      thumbnail: true,
      showThumbByDefault: false,
      currentPagerPosition: 'left',
      thumbWidth: 100,
      thumbHeight: '100px',
      enableThumbDrag: false,
      pullCaptionUp: false,
      animateThumb: false,
      toogleThumb: true,
    })
  } else {
    $('#lightgallery').lightGallery({
      thumbnail: true,
      showThumbByDefault: false,
      thumbWidth: 100,
      thumbHeight: '100px',
      enableThumbDrag: true,
      animateThumb: true,
    })
  }

  function copyUrl() {
    var copyText = document.querySelector('.input-url')

    copyText.select()
    copyText.setSelectionRange(0, 99999)

    document.execCommand('copy')
  }

  $(document).on('click', '#lg-copy-url', function () {
    var inputUrl = $('.input-url')
    var url = window.location.href

    inputUrl.val(url)

    copyUrl()

    $('#modal-copy').modal('show')

    setTimeout(function () {
      $('#modal-copy').modal('hide')
    }, 1500)
  })

  $('.lightgallery-controls--share').on('click', function (e) {
    $(this).toggleClass('is-share')
    e.stopPropagation()
  })

  $('.lightgallery-controls--fullscreen').on('click', function (e) {
    e.preventDefault()
    e.stopPropagation()

    $('.slick-slide.slick-current.slick-active').trigger('click')
  })
})
